import styled from 'styled-components';
import { fonts, colors } from 'stylesheets';

export const Question = styled.div`
  border-bottom: 1px solid ${colors.greyLighter};
  span {
    display: block;
    color: ${colors.greyDark};
  }
  &:last-child {
    border-bottom: none;
  }
`;

export const Title = styled.span`
  font: 500 13px ${fonts.primary};
  text-transform: uppercase;
  margin-bottom: 10px;
  padding-top: 12px;
`;
export const Answer = styled.span`
  font: 300 14px ${fonts.secondary};
  padding-bottom: 17px;
`;

export const PhotoGrid = styled.div`
  margin-top: 10px;
`;

export const Photo = styled.img`
  width: 125px;
  height: 125px;
  margin: 10px;
  object-fit: cover;
  cursor: pointer;
`;

export const BigPicture = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: auto;
    height: 60vh;
    max-width: 100%;
    object-fit: contain;
  }
`;
